import React, { useState } from "react";
import "../style/CandidateForm.css"; // move your CSS there
import { useNavigate } from "react-router-dom";
import { Link } from 'react-router-dom'; // Import Link
import logo from '../assets/images/teteklogo-removebg-preview.png'; // Import the logo

const departmentOptions = {
  "IT Software": ["React", "Python", "Web Development", "MySQL"],
  "IT Hardware": ["Networking", "CCTV", "Router", "Server"],
  "HR & Admin": ["Recruitment", "Payroll", "Employee Relations"],
  "Accounts": ["Tax", "Auditing", "Bookkeeping"],
  "Digital Design": ["Photoshop", "Illustrator", "Canva"],
  "Digital Marketing": ["SEO", "Content Marketing", "Social Media"],
  "Other": [],
};


const CandidateForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    number: "",
    dob: "",
    gender: "",
    maritalStatus: "",
    nationality: "",
    bloodGroup: "",
    positionApplied: "",
    department: "",
    subDepartments: [],
    highestQualification: "",
    yearOfGraduation: "",
    currentEmployer: "",
    totalExperience: "",
    relevantExperience: "",
    skillsCertifications: "",
    highestDegreeType: "",
    isExperienced: "",
  });

  const [files, setFiles] = useState({
    resumeUpload: null,
    photoUpload: null,
    degreeCertificateUpload: null,
    payslipUpload: null,
  });

  const [isExperienced, setIsExperienced] = useState(false);
  const [submissionMessage, setSubmissionMessage] = useState("");

  // Handle text/radio/select changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (name === "isExperienced") {
      setIsExperienced(value === "Yes");
    }
  };

 const handleFileChange = (e) => {
  const { name, files: selectedFiles } = e.target;
  setFiles((prevFiles) => ({
    ...prevFiles,
    [name]: selectedFiles[0], // store file object
  }));
};

const navigate = useNavigate();


  // Submit form
const handleSubmit = async (e) => {
  e.preventDefault();

  const formDataToSend = new FormData();

  // Append all required fields...
  formDataToSend.append("name", formData.name);
  formDataToSend.append("number", formData.number);
  formDataToSend.append("dob", formData.dob);
  formDataToSend.append("gender", formData.gender);
  formDataToSend.append("marital_status", formData.maritalStatus);
  formDataToSend.append("nationality", formData.nationality);
  formDataToSend.append("blood_group", formData.bloodGroup);
  formDataToSend.append("position_applied", formData.positionApplied);
  formDataToSend.append("department", formData.department);
  formDataToSend.append("sub_departments", JSON.stringify(formData.subDepartments));
  formDataToSend.append("basic_qualification", formData.highestQualification);
  formDataToSend.append("year_of_graduation", formData.yearOfGraduation);
  formDataToSend.append("current_employer", formData.currentEmployer);
  formDataToSend.append("total_experience", formData.totalExperience);
  formDataToSend.append("is_experienced", formData.isExperienced === "Yes");


  // File uploads
  if (files.resumeUpload) formDataToSend.append("resume_upload", files.resumeUpload);
  if (files.photoUpload) formDataToSend.append("photo_upload", files.photoUpload);
  if (files.degreeCertificateUpload) formDataToSend.append("degree_certificate_upload", files.degreeCertificateUpload);
  if (files.payslipUpload) formDataToSend.append("payslip_upload", files.payslipUpload);

  // Optional
  if (formData.highestDegreeType) formDataToSend.append("highest_degree_type", formData.highestDegreeType);
  if (formData.relevantExperience) formDataToSend.append("relevant_experience", formData.relevantExperience);
  if (formData.skillsCertifications) formDataToSend.append("skills_certifications", formData.skillsCertifications);

  try {
    const response = await fetch("https://assessment.tetekniqx.com/api/employees/", {
      method: "POST",
      body: formDataToSend,
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error("Error response:", errorData);
      alert("Failed: " + JSON.stringify(errorData));
    } else {
      const data = await response.json();
      console.log("Success:", data);

      // ✅ Save candidate ID (cid) in localStorage
      localStorage.setItem("cid", data.id);

      // Redirect to index page
      navigate("/index");
    }
  } catch (error) {
    console.error("Error submitting form:", error);
  }
};



  return (
    <>
      <div className="candidate-form__header-bar">
        <div className="candidate-form__logo">
          <img src={logo} alt="Vienstereoptic Logo" className="candidate-form__logo-img" />
        </div>
        <Link to="/admin/login" className="admin-login-button">
          <span className="admin-login-icon">🔐</span> Admin Login
        </Link>
      </div>
      <div className="candidate-form__container">
        <div className="candidate-form__header">
          <h1 className="candidate-form__title">Candidate Information Form</h1>
          <p className="candidate-form__description">
            Please fill out the following details for your application. Fields
            marked with <span className="candidate-form__required">*</span> are mandatory.
          </p>
          <div className="candidate-form__header-line"></div>
        </div>

        <form onSubmit={handleSubmit} encType="multipart/form-data" className="candidate-form__form">
          {/* Section 1: Personal Information */}
          <div className="candidate-form__section">
            <h2 className="candidate-form__section-title">Section 1: Personal Information</h2>
            <div className="candidate-form__field">
              <label className="candidate-form__label">Full Name *</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="candidate-form__input"
              />
            </div>

            <div className="candidate-form__field">
              <label className="candidate-form__label">Number *</label>
              <input
                type="text"
                name="number"
                value={formData.number}
                onChange={handleChange}
                required
                className="candidate-form__input"
              />
            </div>

            <div className="candidate-form__field">
              <label className="candidate-form__label">Date of Birth *</label>
              <input
                type="date"
                name="dob"
                value={formData.dob}
                onChange={handleChange}
                required
                className="candidate-form__input"
              />
            </div>

            <div className="candidate-form__field">
              <label className="candidate-form__label">Gender *</label>
              <div className="candidate-form__radio-group">
                {["Male", "Female", "Other", "Prefer not to say"].map((g) => (
                  <div key={g}>
                    <input
                      type="radio"
                      name="gender"
                      value={g}
                      checked={formData.gender === g}
                      onChange={handleChange}
                      required
                      className="candidate-form__radio"
                    />
                    <label className="candidate-form__radio-label">{g}</label>
                  </div>
                ))}
              </div>
            </div>

            <div className="candidate-form__field">
              <label className="candidate-form__label">Marital Status *</label>
              <div className="candidate-form__radio-group">
                {["Single", "Married", "Other"].map((m) => (
                  <div key={m}>
                    <input
                      type="radio"
                      name="maritalStatus"
                      value={m}
                      checked={formData.maritalStatus === m}
                      onChange={handleChange}
                      required
                      className="candidate-form__radio"
                    />
                    <label className="candidate-form__radio-label">{m}</label>
                  </div>
                ))}
              </div>
            </div>

            <div className="candidate-form__field">
              <label className="candidate-form__label">Nationality *</label>
              <input
                type="text"
                name="nationality"
                value={formData.nationality}
                onChange={handleChange}
                required
                className="candidate-form__input"
              />
            </div>

            <div className="candidate-form__field">
              <label className="candidate-form__label">Blood Group *</label>
              <select
                name="bloodGroup"
                value={formData.bloodGroup}
                onChange={handleChange}
                required
                className="candidate-form__select"
              >
                <option value="">Select your Blood Group</option>
                {["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"].map((bg) => (
                  <option key={bg} value={bg}>
                    {bg}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Section 2: Application Details */}
          <div className="candidate-form__section">
            <h2 className="candidate-form__section-title">Section 2: Application Details</h2>
            <div className="candidate-form__field">
              <label className="candidate-form__label">Position Applied For *</label>
              <input
                type="text"
                name="positionApplied"
                value={formData.positionApplied}
                onChange={handleChange}
                required
                className="candidate-form__input"
              />
            </div>
            {/* Department dropdown */}
            <div className="candidate-form__field">
              <label className="candidate-form__label">Department *</label>
              <select
                name="department"
                value={formData.department}
                onChange={(e) => {
                  setFormData({ ...formData, department: e.target.value, subDepartments: [] });
                }}
                required
                className="candidate-form__select"
              >
                <option value="">Select Department</option>
                {Object.keys(departmentOptions).map((d) => (
                  <option key={d} value={d}>{d}</option>
                ))}
              </select>
            </div>

            {/* Multi-select sub-departments */}
            {formData.department && departmentOptions[formData.department].length > 0 && (
              <div className="candidate-form__field">
                <label className="candidate-form__label">Specializations (Select multiple)</label>
                <div className="candidate-form__checkbox-group">
                  {departmentOptions[formData.department].map((sub) => (
                    <label key={sub} className="candidate-form__checkbox-item">
                      <input
                        type="checkbox"
                        value={sub}
                        checked={formData.subDepartments.includes(sub)}
                        onChange={(e) => {
                          let updatedSubs = [...formData.subDepartments];
                          if (e.target.checked) {
                            updatedSubs.push(sub);
                          } else {
                            updatedSubs = updatedSubs.filter((s) => s !== sub);
                          }
                          setFormData({ ...formData, subDepartments: updatedSubs });
                        }}
                        className="candidate-form__checkbox"
                      />
                      {sub}
                    </label>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Section 3: Professional Details */}
          <div className="candidate-form__section">
            <h2 className="candidate-form__section-title">Section 3: Professional Details</h2>
            <div className="candidate-form__field">
              <label className="candidate-form__label">Highest Qualification *</label>
              <input
                type="text"
                name="highestQualification"
                value={formData.highestQualification}
                onChange={handleChange}
                required
                className="candidate-form__input"
              />
            </div>

            <div className="candidate-form__field">
              <label className="candidate-form__label">Year of Graduation *</label>
              <input
                type="text"
                name="yearOfGraduation"
                value={formData.yearOfGraduation}
                onChange={handleChange}
                placeholder="e.g., 2018"
                pattern="\d{4}"
                required
                className="candidate-form__input"
              />
            </div>
            <div className="candidate-form__field">
              <label className="candidate-form__label">Current Employer *</label>
              <input
                type="text"
                name="currentEmployer"
                value={formData.currentEmployer}
                onChange={handleChange}
                required
                className="candidate-form__input"
              />
            </div>

            {isExperienced && (
              <>
                <div className="candidate-form__field">
                  <label className="candidate-form__label">Total Experience *</label>
                  <input
                    type="text"
                    name="totalExperience"
                    value={formData.totalExperience}
                    onChange={handleChange}
                    required
                    className="candidate-form__input"
                  />
                </div>

                <div className="candidate-form__field">
                  <label className="candidate-form__label">Relevant Experience</label>
                  <input
                    type="text"
                    name="relevantExperience"
                    value={formData.relevantExperience}
                    onChange={handleChange}
                    className="candidate-form__input"
                  />
                </div>
              </>
            )}

            <div className="candidate-form__field">
              <label className="candidate-form__label">Skills / Certifications</label>
              <textarea
                name="skillsCertifications"
                value={formData.skillsCertifications}
                onChange={handleChange}
                className="candidate-form__textarea"
              />
            </div>
          </div>

          {/* Section 4: Documents */}
          <div className="candidate-form__section">
            <h2 className="candidate-form__section-title">Section 4: Document Submission</h2>

            <div className="candidate-form__field">
              <label className="candidate-form__label">Upload Resume (PDF only) *</label>
              <input type="file" name="resumeUpload" onChange={handleFileChange} required className="candidate-form__input" accept="application/pdf" />
            </div>

            <div className="candidate-form__field">
              <label className="candidate-form__label">Upload Passport Size Photo *</label>
              <input type="file" name="photoUpload" onChange={handleFileChange} required className="candidate-form__input" />
            </div>

            <div className="candidate-form__field">
              <label className="candidate-form__label">Highest Degree *</label>
              <div className="candidate-form__radio-group">
                {["UG", "PG", "Diploma"].map((deg) => (
                  <div key={deg}>
                    <input
                      type="radio"
                      name="highestDegreeType"
                      value={deg}
                      checked={formData.highestDegreeType === deg}
                      onChange={handleChange}
                      required
                      className="candidate-form__radio"
                    />
                    <label className="candidate-form__radio-label">{deg}</label>
                  </div>
                ))}
              </div>
            </div>

            <div className="candidate-form__field">
              <label className="candidate-form__label">Upload Degree Certificate *</label>
              <input
                type="file"
                name="degreeCertificateUpload"
                onChange={handleFileChange}
                required
                className="candidate-form__input"
              />
            </div>

            <div className="candidate-form__field">
              <label className="candidate-form__label">Are you an experienced candidate? *</label>
              <div className="candidate-form__radio-group">
                <div>
                  <input
                    type="radio"
                    name="isExperienced"
                    value="Yes"
                    checked={formData.isExperienced === "Yes"}
                    onChange={handleChange}
                    required
                    className="candidate-form__radio"
                  />
                  <label className="candidate-form__radio-label">Yes</label>
                </div>
                <div>
                  <input
                    type="radio"
                    name="isExperienced"
                    value="No"
                    checked={formData.isExperienced === "No"}
                    onChange={handleChange}
                    className="candidate-form__radio"
                  />
                  <label className="candidate-form__radio-label">No</label>
                </div>
              </div>
            </div>

            {isExperienced && (
              <div className="candidate-form__field">
                <label className="candidate-form__label">
                  Upload Latest Payslip (or Salary Certificate / Joining Letter) *
                </label>
                <input
                  type="file"
                  name="payslipUpload"
                  onChange={handleFileChange}
                  required
                  className="candidate-form__input"
                />
              </div>
            )}
          </div>

          <div className="candidate-form__actions">
            <button type="submit" className="candidate-form__btn candidate-form__btn--primary">Submit Application</button>
            <button type="reset" className="candidate-form__btn candidate-form__btn--secondary">
              Clear Form
            </button>
          </div>
        </form>

        {submissionMessage && (
          <div id="submissionMessage" className="candidate-form__submission-message candidate-form__submission-message--success">
            {submissionMessage}
          </div>
        )}
      </div>
    </>
  );
};

export default CandidateForm;
